import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const manageDuesPaymentsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'manage'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'manage', itemId] as const,
      }),
  });

export { manageDuesPaymentsKeys };
